import styled from "styled-components";
import logoBrand from "../assets/logo.png";
import Header1 from "../assets/Header-1.jpg";
import img3 from "../assets/Robotic.jpg";
import img4 from "../assets/Playing.jpg";
import img5 from "../assets/Kids.jpg";
import header2 from "../assets/IMG-20250201-WA0005.jpg";
import header3 from "../assets/IMG-20241206-WA0028.jpg";
import header4 from "../assets/IMG-20250516-WA0027.JPG";
import AboutUs from "./AboutUs";
import Footer from "./Footer";
import DeliveryModel from "./DeliveryModel";
import Main from "./styled/Main.styled";
import { useEffect, useRef, useState } from "react";

const Home = () => {
  const [isClick, setIsClick] = useState(false);
  // const [openMenu, setOpenMenu] = useState(null);
  const [isNavVisible, setIsNavVisible] = useState(false);
  // Add a ref for the AboutUs section
  const aboutUsRef = useRef(null);

  // Scroll to AboutUs when ABOUT is clicked
  const handleAboutClick = () => {
    if (aboutUsRef.current) {
      aboutUsRef.current.scrollIntoView({ behavior: "smooth" });
    }
    setIsNavVisible(!isNavVisible);
    setIsClick(!isClick); // Toggle submenu
  };

  // Add a ref for the Footer section
  const footerRef = useRef(null);

  // Scroll to Footer when CONTACT is clicked
  const handleContactClick = () => {
    if (footerRef.current) {
      footerRef.current.scrollIntoView({ behavior: "smooth" });
    }
    setIsNavVisible(!isNavVisible);
    setIsClick(!isClick); // Toggle submenu
  };

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
    setIsClick(!isClick); // Toggle submenu
  };

  return (
    <>
      <nav className="container">
        <NavContainer>
          <div>
            <img src={logoBrand} alt="logo" />
          </div>
          <NavList>
            <li>HOME</li>
            <li onClick={handleAboutClick}>ABOUT</li>
            <li>PROGRAMS</li>
            <li onClick={handleContactClick}>CONTACT</li>
          </NavList>
          <div className="open-menu" onClick={toggleNav}>
            {!isClick ? (
              <i class="fa-solid fa-bars"></i>
            ) : (
              <i class="fa-solid fa-x"></i>
            )}
          </div>
          {isNavVisible && (
            <MobileNav style={{ display: "flex" }}>
              <li>HOME</li>
              <li onClick={handleAboutClick}>ABOUT</li>
              <li>PROGRAMS</li>
              <li onClick={handleContactClick}>CONTACT</li>
            </MobileNav>
          )}
        </NavContainer>
      </nav>
      <Main className="container">
        <ShowCase />
        <section>
          <Category>
            <p>RAISING ROBOTICS CHAMPIONS</p>
            <img src={img3} alt="RAISING ROBOTICS CHAMPIONS" />
          </Category>
          <Category>
            <p>PLAYING S.T.E.A.M</p>
            <img src={img4} alt="PLAYING S.T.E.A.M" />
          </Category>
          <Category>
            <p>GROWING CODES</p>
            <img src={img5} alt="GROWING CODES" />
          </Category>
        </section>
        <a
          href="https://drive.google.com/drive/folders/1GRTOmQXVFv1i3IpMS_hPG_FwdIQlrF8_?usp=sharing"
          target="_blank"
          rel="noreferrer"
        >
          PHOTO LIBRARY
        </a>
        <div ref={aboutUsRef}>
          <AboutUs />
        </div>
        <DeliveryModel />
        <div ref={footerRef}>
          <Footer />
        </div>
      </Main>
    </>
  );
};

const showcaseImages = [Header1, header2, header3, header4];

const ShowCase = () => {
  const [bgIndex, setBgIndex] = useState(0);
  const timerRef = useRef();

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setBgIndex((prev) => (prev + 1) % showcaseImages.length);
    }, 5000);
    return () => clearTimeout(timerRef.current);
  }, [bgIndex]);

  return (
    <ShowCaseStyled bg={showcaseImages[bgIndex]}>
      <h3>WELCOME TO TECH FOR KIDS</h3>
    </ShowCaseStyled>
  );
};

const ShowCaseStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  background-color: rgba(104, 104, 104, 0.1);
  width: 100%;
  overflow: hidden;
  place-items: center;
  background-image: url(${({ bg }) => bg});
  background-size: cover;
  background-position: center;
  position: relative;
  transition: background-image 1s ease-in-out;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.9),
      rgba(0, 0, 0, 0.01)
    );
    height: 200px;
    bottom: 0;
  }
  h3 {
    transform: translateY(100%);
    color: #000;
    background-color: rgba(255, 255, 255, 1);
    padding: 20px 60px;
    letter-spacing: 3px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 0.7rem;
      padding: 20px 30px;
    }
  }
`;

const Category = styled.li`
  text-align: center;
  margin: 0;
  height: 350px;
  display: flex;
  flex-direction: column;
  width: 33.3%;
  padding: 0;
  overflow: hidden;
  position: relative;
  p {
    padding: 25px 0;
    font-size: 0.8rem;
    letter-spacing: 1px;
    font-weight: bold;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 1.1rem;
    }
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 250px;
    display: block;
    border: 2px solid #000;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
  }
`;

const NavContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  margin-bottom: 40px;
  font-family: "Orbitron", sans-serif;

  div {
    img {
      width: 120px;
      vertical-align: middle;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 100%;
    padding: 10px 20px;
    margin-bottom: 20px;

    i {
      font-size: 1.5rem;
      cursor: pointer;
      color: ${({ theme }) => theme.color.azure};
    }
  }
`;

const MobileNav = styled.div`
  height: 300px;
  width: 100vw;
  position: absolute;
  background-color: #fff;
  z-index: 99;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  flex-direction: column;
  align-items: center;
  list-style: none;
  margin: 70px 0;
  li {
    padding: 20px 0;

    a {
      text-decoration: none;
      color: black;
    }
  }
`;

const NavList = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  padding: 0 10px;
  li {
    cursor: pointer;
    font-weight: 600;
    color: ${({ theme }) => theme.color.slate500};
    &:hover {
      color: ${({ theme }) => theme.color.orange};
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

export default Home;
